import { Participant } from '@zoom/videosdk'

export const EmptyPromise: Promise<''> = Promise.resolve('')

export interface IVideoClient {
  emit(event: string, ...args: any[]): void
  getUser(userId: number): Participant | undefined
  shouldThrowPermissionsErrors(): boolean
}
